import Button from '@components/Button';
import WidgetItem from '@components/PlayerWidgets/WidgetItem';
import Tabbar from '@components/Tabbar';
import { MARKER_TITLE_DEFAULT } from '@modules/sandTable/constants';
import { isMapMarkerWithTitleSetting } from '@modules/sandTable/utils/markerTypeCheck';
import {
  $editingMapMarker,
  $editingMapMarkerApi,
} from '@stores/editingMarkerStores';
import { STMapMarkerType } from '@types';
import { useStore } from 'effector-react';
import { useState } from 'react';
import { TitlePosSetting } from './TitlePosSetting';
import { TitleStylesSetting } from './TitleStylesSetting';
import { TitleTextSetting } from './TitleTextSetting';

export function TitleWidget() {
  const { marker } = useStore($editingMapMarker)!;

  const noPosSettings = marker.type === STMapMarkerType.text;

  const [tab, setTab] = useState(0);
  const handleReset = () => {
    $editingMapMarkerApi.update((draft) => {
      if (isMapMarkerWithTitleSetting(draft)) {
        if (tab === 0) {
          draft.titleSetting.background = MARKER_TITLE_DEFAULT.background;
          draft.titleSetting.styleType = MARKER_TITLE_DEFAULT.styleType;
        } else if (tab === 1) {
          draft.titleSetting.font = MARKER_TITLE_DEFAULT.font;
          draft.titleSetting.writingMode = MARKER_TITLE_DEFAULT.writingMode;
          draft.titleSetting.align = MARKER_TITLE_DEFAULT.align;
        } else if (tab === 2) {
          draft.titleSetting.edge = MARKER_TITLE_DEFAULT.edge;
          draft.titleSetting.ox = MARKER_TITLE_DEFAULT.ox;
          draft.titleSetting.oy = MARKER_TITLE_DEFAULT.oy;
        }
      }
    });
  };

  if (!isMapMarkerWithTitleSetting(marker)) return null;

  return (
    <WidgetItem type="title" title="标题高级设置">
      <Tabbar
        className="mb-10"
        tabs={noPosSettings ? ['样式', '文字'] : ['样式', '文字', '位置']}
        activeIndex={tab}
        onChange={setTab}
      />
      {tab === 0 && <TitleStylesSetting titleSetting={marker.titleSetting} />}
      {tab === 1 && <TitleTextSetting titleSetting={marker.titleSetting} />}
      {tab === 2 && <TitlePosSetting titleSetting={marker.titleSetting} />}
      <Button className="w-full" onClick={handleReset}>
        重置设置
      </Button>
    </WidgetItem>
  );
}
